/**
 * A global namespace for `pointerdown` event.
 */
const pointerdownEvent = "pointerdown";
export default pointerdownEvent;
